import React from 'react';

import { Box, Center } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import CartButton from 'components/app-header/mobile-header/cart-button';
import { HamburgerButton } from 'components/app-header/mobile-header/hamburger-button';
import {
  Header,
  LinkNoDecoration,
  MenuButtonContainer,
  MobileHeaderContainer,
} from 'components/app-header/styled';
import Logo from 'components/logo';
import SkipToContent from 'components/skip-content';
import { TopServiceMode } from 'components/top-service-mode';
import { useIsTopServiceModeEnabled } from 'experiments/service-mode/use-is-top-servie-mode-enabled';
import { useRoute } from 'hooks/navigation/use-route';
import useAuthFlow from 'state/auth/hooks/use-auth-flow';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLoadingIndicator } from 'state/loading';
import { useMobileHeaderBackButton, useMobileHeaderComponent } from 'state/mobile-header-nav';
import { useReversedUIContext } from 'state/reversed-ui';
import { routes } from 'utils/routing';

import SignupMobileHeader from '../signup-mobile-header';
import {
  StyledCenterSpacer,
  StyledLogo,
  StyledRightSpacer,
  TopServiceModeContainer,
} from '../styled';

import MobileHeaderCta from './mobile-header-cta';

const StandardMobileHeader = () => {
  const BackButtonComponent = useMobileHeaderBackButton();
  const { pathname } = useRoute();

  const LoadingIndicator = useLoadingIndicator();
  const { formatMessage } = useIntl();
  const enableTopServiceMode = useIsTopServiceModeEnabled();
  const { reversedUI } = useReversedUIContext();

  const isHamburgerMenuEnabled = useFlag(LaunchDarklyFlag.ENABLE_HAMBURGER_MENU_ON_MOBILE);

  const shouldShowHamburgerMenu =
    pathname.includes(formatMessage({ id: 'routes.termsConditionsRewards' })) ||
    pathname.includes(formatMessage({ id: 'routes.rewardsPolicy' })) ||
    pathname.includes(formatMessage({ id: 'routes.deliveryTerms' })) ||
    pathname.includes(formatMessage({ id: 'routes.termsOfService' })) ||
    pathname.includes(formatMessage({ id: 'routes.privacyPolicy' }));

  const { isInAuthFlow } = useAuthFlow();
  if (isInAuthFlow) {
    return <SignupMobileHeader />;
  }

  const LeftSideComponent =
    (!shouldShowHamburgerMenu && BackButtonComponent) ||
    (isHamburgerMenuEnabled ? HamburgerButton : () => null);

  return (
    <MobileHeaderContainer
      accessibilityLabel={formatMessage({ id: 'primaryNavLinks' })}
      testID="mobile-header"
      reversed={reversedUI}
    >
      <Center>
        <Box width="full" maxWidth={Styles.layout.sectionMaxWidth}>
          <Header>
            <MenuButtonContainer>
              <LeftSideComponent />
            </MenuButtonContainer>
            <SkipToContent />
            <StyledCenterSpacer>
              <LinkNoDecoration to={routes.base}>
                <StyledLogo testID="mobile-header-logo">
                  <Logo padding="0" />
                </StyledLogo>
              </LinkNoDecoration>
            </StyledCenterSpacer>
            <StyledRightSpacer>
              <MobileHeaderCta />
              <CartButton />
            </StyledRightSpacer>
          </Header>
          <LoadingIndicator />

          {enableTopServiceMode && (
            <TopServiceModeContainer>
              <TopServiceMode />
            </TopServiceModeContainer>
          )}
        </Box>
      </Center>
    </MobileHeaderContainer>
  );
};

export default function MobileHeader() {
  const HeaderComponent = useMobileHeaderComponent();

  return HeaderComponent ? <HeaderComponent /> : <StandardMobileHeader />;
}
